import { ParsedUrlQuery } from 'querystring';
import { isArray } from '@pe-libs/react-components/build/lib/helper';

export const getParameters = ({
  id = '',
  profile = '',
  profileId = '',
  email = '',
  lang = 'de-de',
}: ParsedUrlQuery) => ({
  id: isArray(id) ? id[0] : id,
  profile: isArray(profile) ? profile[0] : profile,
  profileId: isArray(profileId) ? profileId[0] : profileId,
  email: isArray(email) ? email[0] : email,
  lang: isArray(lang) ? lang[0] : lang,
});
